import HttpService from "./HttpService";

async function fetchTransfers(idEmployer) {
  const response = await HttpService.getAxiosClient().get(
    window.API_URL + `/transfer/all?idEmployer=${idEmployer}`
  );
  return response;
}

async function confirmTransfer(transferId) {
  const response = await HttpService.getAxiosClient().post(
    window.API_URL + `/transfer/${transferId}/confirm`
  );
  return response;
}

async function fetchSvbTransfers(idEmployer, from, to) {
  return HttpService.getAxiosClient().get(window.API_URL + "/transfer/svb", {
    params: { idEmployer, from, to },
  });
}

async function fetchSvbStudies(idEmployer) {
  return HttpService.getAxiosClient().get(window.API_URL + "/transfer/svb/studies", {
    params: { idEmployer },
  });
}

async function resolveSvbTransfer(request) {
  return HttpService.getAxiosClient().post(window.API_URL + "/transfer/svb/resolve", request);
}

async function fetchSvbFeeTypes() {
  return HttpService.getAxiosClient().get(window.API_URL + "/fee-types/all");
}

async function rejectTransfer(transferId) {
  const response = await HttpService.getAxiosClient().post(
    window.API_URL + `/transfer/${transferId}/reject`
  );
  return response;
}

const TransferService = {
  fetchTransfers,
  fetchSvbTransfers,
  fetchSvbStudies,
  fetchSvbFeeTypes,
  resolveSvbTransfer,
  confirmTransfer,
  rejectTransfer,
};

export default TransferService;
